// extracted by mini-css-extract-plugin
export default {"privacy":"ZombieLoop_privacy__urw9J","listLink":"ZombieLoop_listLink__pQLNI"};